import { StyledLabel } from "../elements/inputGroup/styledInputGroup";
import { StyledPaymentMethodItem, StyledWrapperPaymentItem } from "./styledProfileActions";
import { StyledPaymentMethodsIcons } from "../styles/StyledPaymentMethodsIcons";
import InputGroup from "../elements/inputGroup/InputGroup";
import BetAction from "../elements/betAction/BetAction";
import AlertMessage from "../elements/alert/Alert";
import { StyledButton } from "../styles/styledButton";
import Dialog from "rc-dialog";
import React, {useContext, useEffect, useRef, useState} from "react";
import { useBetween } from "use-between";
import ProfileActionsStates from "./ProfileActionsStates";
import BalanceStates from "../games/BalanceStates";
import { useTranslation } from "react-i18next";
import userAuthenticationConfig from "../../utils/userAuthenticationConfig";
import { responseStatus } from "../../utils/consts";
import { closableNotification } from "../elements/notification/ClosableNotification";
import http from "../../http";
import ReCaptcha from "../elements/reCaptcha/ReCaptcha";
import {AppContext} from "../../App";

const SendTipWindow = ({ activeNickname, room }) => {
  const { user } = useContext(AppContext);

  const { t } = useTranslation("siteOptions");

  const {
    visibleTipWindow,
    setVisibleTipWindow
  } = useBetween(ProfileActionsStates);

  const {
    paymentMethods,
    setBalance,
    setPaymentMethods
  } = useBetween(BalanceStates);

  const [activePaymentInfo, setActivePaymentInfo] = useState(JSON.parse(localStorage.getItem("paymentMethod")) ?
    JSON.parse(localStorage.getItem("paymentMethod")) :
    paymentMethods[0]);

  const [valueNumber, setValueNumber] = useState(null);
  const recaptchaRef = useRef(null);

  useEffect(() => {
    if(!valueNumber){
      setValueNumber(activePaymentInfo ? activePaymentInfo?.fee?.min : paymentMethods[0]?.fee?.min);
    }
  }, [activePaymentInfo, paymentMethods]);
  const selectPaymentMethod = (value) => {
    localStorage.setItem("paymentMethod", JSON.stringify(value));

    setActivePaymentInfo(value);
    setBalance(value.balances ? value.balances.amount : 0);
  };

  useEffect(() => {
    if (paymentMethods.length > 0) return;
    getPaymentMethodsSystem();
  }, []);

  const getPaymentMethodsSystem = () => {
    http.get(`/api/payment-methods`, userAuthenticationConfig()).then(response => {
      if (response.status === responseStatus.HTTP_OK) {
        setPaymentMethods(response.data["hydra:member"]);
      }
    }).catch(error => {
      closableNotification(error.response.data.error, "error");
    }).finally(() => {
    });
  };

  // const sendTip = (captchaToken) => {
  const sendTip = (captchaToken) => {
    if(!user.roles.includes('ROLE_MANAGER')){
      closableNotification(t('sendTipError'), "error");
      setVisibleTipWindow(false);
      return null;
    }

    let data = {
      recipientNickname: activeNickname,
      currency: activePaymentInfo.currency.asset,
      value: valueNumber.toString(),
      room: room ?? null,
      // captchaToken
    };

    http.post("/api/tips", data, userAuthenticationConfig(false)).then(response => {
      if (response.status === responseStatus.HTTP_CREATED) {
        closableNotification("Tip successfuly sent", "success");
        setVisibleTipWindow(false);

      }
    }).catch(error => {
      if (error.response.status === responseStatus.HTTP_BAD_REQUEST || error.response.status ===
        responseStatus.HTTP_ERROR_VALIDATION || error.response.status === responseStatus.HTTP_UNAUTHORIZED) {
        closableNotification(error.response.data.error, "error");
      }

      if (error.response.status === responseStatus.HTTP_UNAUTHORIZED) {
        closableNotification(error.response.data.detail, "error");
      }
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    // const captchaToken = recaptchaRef.current.getValue();
    // recaptchaRef.current.reset();

    // sendTip(captchaToken);
    sendTip();
  };

  const handleInput = (valueNumber) => {
    const value = `${valueNumber}`.replaceAll(',', '.');
    if (value && parseFloat(value) && value.includes('.')) {
      let [intPart, decimalPart] = value.split('.');
      if (decimalPart.length > 8) {
        decimalPart = decimalPart.substring(0, 8);
      }
      if (intPart === '') {
        intPart = 0;
      }
      setValueNumber([intPart, decimalPart].join('.'))
    } else {
      setValueNumber(value);
    }
  }

  return (
    <Dialog
      visible={visibleTipWindow}
      wrapClassName="default-modal-wrapper"
      onClose={() => setVisibleTipWindow(false)}
      animation="zoom"
      maskAnimation="fade"
      title={`${t("sendTipTo")}${activeNickname}`}
      forceRender={false}
      className="default-modal"
    >
      <StyledLabel>{t("chooseTheCoin")}:</StyledLabel>
      {
        paymentMethods && (
          <StyledWrapperPaymentItem>
            {
              paymentMethods.length !== 0 ? paymentMethods.map((value, key) => (
                <StyledPaymentMethodItem
                  key={key}
                  onClick={() => selectPaymentMethod(value)}
                  className={`payment-method-item ${activePaymentInfo?.currency?.asset === value.currency.asset ? "active" : ""}`}
                >
                  <StyledPaymentMethodsIcons className={`payment-method-${value.currency.asset}`}/>
                </StyledPaymentMethodItem>
              )) : <StyledPaymentMethodItem>{t("loading")}</StyledPaymentMethodItem>
            }
          </StyledWrapperPaymentItem>
        )
      }
      <InputGroup
        autocomplete="off"
        id="amount"
        type="number"
        label={t("enterSum")}
        name="amount"
        value={valueNumber}
        betAction={
          <BetAction
            value={valueNumber}
            setValue={setValueNumber}
            min={activePaymentInfo?.minTip}
            max={activePaymentInfo?.maxTip}
          />}
        hintsWithMax={{
          ...activePaymentInfo,
          fee: {
            ...activePaymentInfo,
            min: activePaymentInfo?.minTip?.toFixed(8),
            max: activePaymentInfo?.maxTip?.toFixed(8)
          }
        }}
        handleInput={handleInput}
      />
      <AlertMessage
        type="warning"
        message={t("weRecommendSettingUp")}
        mt="20"
        mb="20"
      />
      {/*<ReCaptcha recaptchaRef={recaptchaRef}/>*/}
      <div className="confirm-action">
        <StyledButton
          color="main"
          type="submit"
          width="100"
          onClick={handleSubmit}
        >Send tip</StyledButton>
      </div>
    </Dialog>
  );
};

export default SendTipWindow;
